import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model";

export class CreateEscritoVersionRequest  extends CreateKeyValueRequest{

  titulo!: string | null;
  cuerpoHTML!: string | null;
  fechaAlta!: string;
  fechaVersion!: string;
  idEscrito!: number;
  idUsuario!: number;


}
